module.exports = __webpack_public_path__ + "img/video6.cf879fe8.jpg";